import React from 'react'
import { Row, Col, FormGroup, Label, Input, Switch, FormSection } from 'twyne-new.ui';

const PasswordForm = ({data, onChange, disabled}) => {
  return (
    <div>
      <Row>
        <Col size="6">
          <FormGroup>
            <Label>Title</Label>
              <Input type="text" value={data.title || ''}
                onChange={(e) => onChange('title', e.target.value)} disabled={disabled}
                />
          </FormGroup>
        </Col>
        <Col size="6">
          <FormGroup>
            <Label>Instructions</Label>
              <Input type="text" value={data.instructions || ''}
                onChange={(e) => onChange('instructions', e.target.value)} disabled={disabled}
                />
          </FormGroup>
        </Col>
        <Col size="12">
          <FormSection>
            Visual configurations
          </FormSection>
        </Col>
        <Col size='4'>
          <FormGroup>
            <Label>Password Width</Label>
              <Input type="text" value={data.password_width || '300px'}
                onChange={(e) => onChange('password_width', e.target.value)} disabled={disabled}
                />
          </FormGroup>
        </Col>
        <Col size='4'>
          <FormGroup>
            <Label>Fields Vertical?</Label>
            <Switch
              onChange={(e) => onChange('alignment', e.target.checked)}
              checked={data.alignment || false}
              disabled={disabled}
            />
          </FormGroup>
        </Col>
        <Col size='4'>
          <FormGroup>
            <Label>Form Centered?</Label>
            <Switch
              onChange={(e) => onChange('form_centered', e.target.checked)}
              checked={data.form_centered || false}
              disabled={disabled}
            />
          </FormGroup>
        </Col>
      </Row>
      
      
    </div>
  );
}

export default PasswordForm;